var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p5-sketch"},[(_vm.show)?_c('button',{on:{"click":function($event){_vm.show = true}}},[_vm._v("start")]):_vm._e(),_vm._v(" "),_c(_vm.name,{tag:"component",attrs:{"width":_vm.dimensions.width,"height":_vm.dimensions.height,"play":_vm.isVisible},on:{"user-interaction":function($event){return _vm.$emit('user-interaction')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acbec264","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/P5Sketch.vue
// module id = null
// module chunks = 